import { put } from 'redux-saga/effects';
import appActions from '../../Containers/App/actions';

/**
 * Function to handle errors in sagas, separate login errors from others
 * @param {object} action the action being passed to the saga
 * @param {object} error the error being passed to the saga
 *
 * @returns {nothing} Throws the error
 */
export function* handleError(action, error, reject) {
  if (reject) reject(error);
  if (error.status === 401) {
    yield put(appActions.loginError(error.data));
  }
  yield put(action(error));
}

export default { handleError };
